export default __webpack_public_path__ + "static/media/Gov-Icons-Logomark.bc4ae3ee.png";